(function () {
	const twentytwenty = () => {
		if (typeof jQuery !== 'undefined' && typeof jQuery.fn !== 'undefined' && typeof jQuery.fn.twentytwenty !== 'undefined') {
			jQuery(".twentytwenty-container").twentytwenty({default_offset_pct: 0.5});
		}
	}
	
	// Use jQuery ready if available, otherwise wait for it
	function initWhenReady() {
		if (typeof jQuery !== 'undefined') {
			// jQuery is loaded, use jQuery ready
			jQuery(document).ready(function() {
				// Wait a bit more for twentytwenty plugin to be ready
				setTimeout(function() {
					if (typeof jQuery.fn.twentytwenty !== 'undefined') {
						twentytwenty();
					} else {
						// Plugin not ready yet, wait more
						setTimeout(function() {
							if (typeof jQuery.fn.twentytwenty !== 'undefined') {
								twentytwenty();
							}
						}, 200);
					}
				}, 100);
			});
		} else {
			// jQuery not loaded yet, wait and retry
			setTimeout(initWhenReady, 50);
		}
	}
	
	// Start initialization
	initWhenReady();
	
	// Re-initialize when sections are loaded in theme editor
	document.addEventListener('shopify:section:load', function () {
		setTimeout(function() {
			twentytwenty();
		}, 200);
	});
})();
